/* global globalThis */
import { Buffer } from "buffer";
import process from "process/browser";

globalThis.Buffer = globalThis.Buffer || Buffer;
globalThis.process = globalThis.process || process;

if (typeof window !== "undefined") {
  window.Buffer = globalThis.Buffer;
  window.process = globalThis.process;
}
